import React, { PureComponent } from 'react'
import Autosuggest from 'react-autosuggest'
import { Paper } from '@material-ui/core'
import { deburr } from 'lodash'

import { Input, Suggestions, SimpleInput } from './components'

export class AutocompleteBase extends PureComponent {
  state = {
    suggestions: [],
  }

  getSuggestions = value => {
    const inputValue = deburr(value.trim()).toLowerCase();
    const inputLength = inputValue.length;
    let count = 0;
  
    return inputLength === 0
      ? []
      : this.props.suggestion.filter(suggestion => {
        const keep = count < 5 && suggestion.label.toLowerCase().includes(inputValue)
  
        if (keep) {
          count += 1;
        }
  
        return keep;
      })
  }

  getSuggestionValue = suggestion => suggestion.label

  handleSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    })
  }

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    })
  }

  onChange = (e, { newValue }) => {
    const { name, formValueChange, form } = this.props

    formValueChange(form, name, newValue)
  }

  render() {
    const { classes, label, name, value, onChange, onBlur, form, ...props } = this.props

    const renderInputComponent = form ? Input : SimpleInput

    if (props.formValueChange) {
      delete props.formValueChange
    }
    
    const autosuggestProps = {
      renderInputComponent,
      suggestions: this.state.suggestions,
      onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
      getSuggestionValue: this.getSuggestionValue,
      renderSuggestion: Suggestions
    }

    return (
      <Autosuggest
        {...autosuggestProps}
        inputProps={{
          label,
          name,
          onBlur,
          value: value || '',
          onChange: onChange ? onChange : this.onChange,
          ...props
        }}
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
        }}
        renderSuggestionsContainer={options => (
          <Paper {...options.containerProps} square>
            {options.children}
          </Paper>
        )}
      />
    )
  }
}

AutocompleteBase.defaultProps = {
  suggestion: []
}



// WEBPACK FOOTER //
// ./src/components/Autocomplete/Autocomplete.js